"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCORECARD_CRITERIA = exports.GATE_FIELD_KEYS = void 0;
/** Gate fields named on `POST /public/lead/gate`. `keyCollection` is required. */
exports.GATE_FIELD_KEYS = ["stage", "keyCollection", "name", "whatsapp", "marketingOptIn"];
/**
 * The 11 criteria in scoring order, with Hausmark's max points (TRD §11.2).
 * Titles are the `criterion` string on `answer_given`.
 */
exports.SCORECARD_CRITERIA = [
    { title: "Getting Started", maxPoints: 5 },
    { title: "Understand Your Needs", maxPoints: 12 },
    { title: "Professional Advice", maxPoints: 12 },
    { title: "Design Fit", maxPoints: 11 },
    { title: "Project Monitoring", maxPoints: 11 },
    { title: "Commitment Confidence", maxPoints: 15 },
    { title: "Quality Showcase", maxPoints: 5 },
    { title: "Trust & Credentials", maxPoints: 8 },
    { title: "Escrow Payment", maxPoints: 5 },
    { title: "Hausmark Confidence", maxPoints: 10 },
    { title: "Online Presence", maxPoints: 6 },
];
